import React, { Component } from 'react';

import Chance from 'chance';

class Character extends Component {

	constructor(props) {
		super(props);
		this.state = {character: false};
	}

	random(max) {
		var value = Math.round(Math.random() * (max - 1));
		return value;
	}
	
	d(amount, val) {
		var result = 0;
		for (var i = 0; i < amount; i++) {
			result += this.random(val) + 1;
		}
		return result;
	}
	
	parseAmounts(gear) {
		var regex = /\(\d+d\d+/g;
		var obj = this;
		var output = gear.replace(regex, function (amount) {
			return amount.toUpperCase();
		});
		
		regex = /\d+d\d+\)/g;
		output = output.replace(regex, function (amount) {
			return amount.toUpperCase();
		});
		
		regex = /\d\+\d+d\d+/g; 
		output = output.replace(regex, function (amount) {
			var split1 = amount.split("+");
			var solid = split1[0];
			var numbers = split1[1].split("d");
			var dice = numbers[0];
			var faces = numbers[1];
			return parseInt(split1) + obj.d(dice, faces);
		});
		
		regex = /\d+d\d+\+\d/g; 
		output = output.replace(regex, function (amount) {
			var split1 = amount.split("+");
			var solid = split1[1];
			var numbers = split1[0].split("d");
			var dice = numbers[0];
			var faces = numbers[1];
			return parseInt(split1) + obj.d(dice, faces);
		});
		
		regex = /\d+d\d+/g;
		output = output.replace(regex, function (amount) {
			var numbers = amount.split("d");
			var dice = numbers[0];
			var faces = numbers[1];
			return obj.d(dice, faces);
		});
		return output;
	}
	
	rollGender() {
		var genders = ["male", "female"];
		return genders[this.random(2)];		
	}
	
	romanize (num) {
		if (!+num)
			return NaN;
		var digits = String(+num).split(""),
			key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
				   "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
				   "","I","II","III","IV","V","VI","VII","VIII","IX"],
			roman = "",
			i = 3;
		while (i--)
			roman = (key[+digits.pop() + (i * 10)] || "") + roman;
		return Array(+digits.join("") + 1).join("M") + roman;
	}
	
	getName(gender, race) {
		
		var chance = new Chance();
		var nationality = "en";
		if (Math.random() > 0.9)
			nationality = "it";
		if (race === "Robot") {
			var robotPrefix = ["XT-", "RC-", "BD--", "Arti", "LuX"];
			var robotNumber = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09"];
			var robotLetter = ["ALPHA", "BETA", "GAMMA", "DELTA", "OMEGA", "ZETA", "EPSILON"];
			var firstName = chance.first({gender: gender, nationality: nationality});
			
			var series = robotPrefix[this.random(robotPrefix.length)];
			if (Math.random() > 0.9)
				series = series + robotLetter[this.random(robotLetter.length)];
			else {
				var number = this.random(60);
				if (number > 10)
					series = series + number;
				else
					series = series + robotNumber[this.random(robotNumber.length)];
			}
				
			return series + ' "' + firstName + '"';
		} else if (race === "Gray") {
			var firstName = chance.first({gender: gender, nationality: nationality});
			var number = this.romanize(this.random(10000));
			return firstName + " " + number;			
		}
		else {
			return chance.name({gender: gender, nationality: nationality});
		}
	}
	
	rollStat() {
		var stat = this.d(3, 6);
		return stat;
	}
	
	getModifier(stat) {
		var mods = this.props.modifiers;
		var mod = parseInt(mods[stat - 3][1], 10);
		return mod;
	}
	
	getArmor(mod) {
		return 10 + mod;
	}
	
	rollHp(mod) {
		return Math.max(1, this.d(1, 4) + mod);
	}
	
	rollLuck() {
		var luckyroll = this.props.luckyroll[this.random(this.props.luckyroll.length)][0];
		return luckyroll;
	}
	
	rollOccupation() {
		var occupation = this.props.occupation[this.random(this.props.occupation.length)];
		return occupation;
	}
	
	rollRace() {
		var race = this.props.race[this.random(this.props.race.length)][0];
		return race;
	}
	
	rollRandomEquipment(occupation, item1, item2, cover, justTrappings) {
		var equipment = [];
		equipment.push(this.parseAmounts(item1));
		if (["Peddler", "Merchant", "Junk Digger"].includes(occupation)) {
			var amount = this.d(1, 3);			
			for (var i = 0; i < amount; i++) {
				var item = this.parseAmounts(this.props.equipment[this.random(this.props.equipment.length)][0]);
				equipment.push(item);
			}
		} else {
			if (occupation === "Raider Spy") {
				var additionalEquipment = this.rollRandomEquipment(cover[0], cover[1], cover[2], false, true);
				equipment.push(...additionalEquipment);
			} else {
				equipment.push(this.parseAmounts(item2));	
			}			
		}
		if (! justTrappings)
			equipment.push(this.parseAmounts(this.props.equipment[this.random(this.props.equipment.length)][0]));		
		return equipment;	
	}
	
	rollStartingCash() {
		var cash = this.d(5, 12);
		return cash;
	}
	
	componentWillMount() {
		var gender = this.rollGender();
		var race = this.rollRace();
		var name = this.getName(gender, race);
		if (race === "Robot" || race === "Gray")
			gender = "--";
		
		var strength = this.rollStat();
		var agility = this.rollStat();
		var stamina = this.rollStat();
		var personality = this.rollStat();
		var intelligence = this.rollStat();
		var luck = this.rollStat();
		
		var strengthMod = this.getModifier(strength);
		var agilityMod = this.getModifier(agility);
		var staminaMod = this.getModifier(stamina);
		var personalityMod = this.getModifier(personality);
		var intelligenceMod = this.getModifier(intelligence);
		var luckMod = this.getModifier(luck);
		
		if (strengthMod >= 0) strengthMod = "+" + strengthMod;
		if (agilityMod >= 0) agilityMod = "+" + agilityMod;
		if (staminaMod >= 0) staminaMod = "+" + staminaMod;
		if (personalityMod >= 0) personalityMod = "+" + personalityMod;
		if (intelligenceMod >= 0) intelligenceMod = "+" + intelligenceMod;
		if (luckMod >= 0) luckMod = "+" + luckMod;
		
		var reflexSave = agilityMod;
		var fortitudeSave = staminaMod;
		var willSave = intelligenceMod;
		
		var luckyroll = this.rollLuck();
		var occupation = this.rollOccupation();
		var occupationName = occupation[0];
		var occupationWeapon = occupation[1];
		var occupationItem = occupation[2];
		var cover = false;
		if (occupationName === "Raider Spy") {
			cover = this.rollOccupation();
			while (cover[0] === "Raider Spy") {
				cover = this.rollOccupation();
			}			
		}
				
		var equipment = this.rollRandomEquipment(occupationName, occupationWeapon, occupationItem, cover);
		
		var cash = this.rollStartingCash();
		var ac = this.getArmor(this.getModifier(agility));
		var hp = this.rollHp(this.getModifier(stamina));
		
		var character = {
			name: name,
			gender: gender,
			stats: {
				strength: [strength, strengthMod],
				agility: [agility, agilityMod],
				stamina: [stamina, staminaMod],
				personality: [personality, personalityMod],
				intelligence: [intelligence, intelligenceMod],
				luck: [luck, luckMod]
			},
			saves: {
				reflex: reflexSave,
				fortitude: fortitudeSave,
				will: willSave
			},
			luckyRoll: luckyroll,
			occupation: occupationName,
			cover: cover,
			race: race,
			equipment: equipment,
			cash: cash,
			ac: ac,
			hp: hp
		}
		console.log(character);
		this.setState({character: character});
	}

	render() {
		var s = this.state;
		var c = s.character;
		return (
			<div className="Character">
			
			{ c ? (
				<div className="CharacterInner">
				<div className="CharacterBackground"/>
					<div className="Profile">
						<div className="Name">Name: {c.name}</div>
						<div className="Gender">Gender: {c.gender}</div>
						<div className="Race">Race: {c.race}</div>
						<div className="Occupation">Occupation: {c.occupation} {c.cover ? "(Cover: " + c.cover[0] + ")" : ""}</div>					
					</div>
					<div className="Numbers">
						<div className="Stats">
							<div key="str" className="Stat"><div className="StatName">STR</div><div className="StatValue">{c.stats.strength[0]}</div><div className="StatModifier">({c.stats.strength[1]})</div></div>
							<div key="agi" className="Stat"><div className="StatName">AGI</div><div className="StatValue">{c.stats.agility[0]}</div><div className="StatModifier">({c.stats.agility[1]})</div></div>
							<div key="sta" className="Stat"><div className="StatName">STA</div><div className="StatValue">{c.stats.stamina[0]}</div><div className="StatModifier">({c.stats.stamina[1]})</div></div>
							<div key="per" className="Stat"><div className="StatName">PER</div><div className="StatValue">{c.stats.personality[0]}</div><div className="StatModifier">({c.stats.personality[1]})</div></div>
							<div key="int" className="Stat"><div className="StatName">INT</div><div className="StatValue">{c.stats.intelligence[0]}</div><div className="StatModifier">({c.stats.intelligence[1]})</div></div>
							<div key="luc" className="Stat"><div className="StatName">LUC</div><div className="StatValue">{c.stats.luck[0]}</div><div className="StatModifier">({c.stats.luck[1]})</div></div>
						</div>
						<div className="Saves">
							<div key="ref" className="Save">REFL: {c.saves.reflex}</div>
							<div key="fort" className="Save">FORT: {c.saves.fortitude}</div>
							<div key="will" className="Save">WILL: {c.saves.will}</div>
						</div>
						<div className="Survive">
							<div className="AC">AC: {c.ac}</div>
							<div className="HP">HP: {c.hp}</div>
						</div>
					</div>
					<div className="LuckyRoll">Lucky Roll<br/> {c.luckyRoll} ({c.stats.luck[1]})</div>
					
					<div className="Equipment">Equipment: {c.equipment.map(function(item, key) { return (<div key={key} className="EquipmentItem">- {item}</div>); })}
						<div key="cash" className="EquipmentItem">- {c.cash}cp</div>
					</div>
					
				</div>
			) : null }
		</div>		
		);
	}
}

export { Character };


// WEBPACK FOOTER //
// ./src/components/Character.js